/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AutonomousVehicleRegistrationStatus {
  DRAFT = 'draft',
  UNDER_REVIEW = 'under_review',
  AUTHORIZED = 'authorized',
  AUTHORIZATION_RESTRICTED = 'authorization_restricted',
  NOT_AUTHORIZED = 'not_authorized',
}
